export default {
  actions: '我们的行动:研发创新',
  ac_ground: {
    ac0: '加大研发投入',
    ac0text:
      '公司持续穷实技术实力，加大研发投入，加强高端科技人才队伍建设，保持企业长久的创新力',
    ac1: '研发投入经费',
    ac1text: '2025年，公司研发投入42亿元，同比增长32%',

    ac2: '研发技术人员',
    ac2text: '截至2025年底，研发技术人员7625人，占员工总数40%',
    ac3: '行业高质量发展',
    ac3text: '我们全面推进技术革新与产品创新，助推行业高质量发展',
  },
  project: {
    hotel: '星级酒店',
    hospital: '医院工程',
    school: '学校工程',
    company: '地产公司',
    other: '其他重点工程',
  },
  development: '可持续发展治理架构',
  developimg: require('@/assets/images/sustainability/susicon.png'),
};
